import R from 'ramda'
import {defineMessages} from 'react-intl'

import addNotification from './addNotification'

import {getDetails} from '../api/search'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "The details of this estate could not be retrieved, try again later", 
    defaultMessage: "The details of this estate could not be retrieved, try again later"
  }
})
const notification = {type: "error", message: messages.message, title: messages.title} 
const onComplete = (dispatch, estateId) => (err, details) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("Failed to fetch details", err)
  }
  dispatch({type: 'load_estate_details', estateId, details})
}

export default (estateId) => (dispatch, getState) => {
  const detailsIsInCache = R.path(["estates", estateId, "details"], getState())
  if(detailsIsInCache) { return }
  getDetails(estateId, onComplete(dispatch, estateId))
  
}



/** WEBPACK FOOTER **
 ** ./app/actions/fetchDetails.js
 **/